<template>
    <div class="detailText detailText-emptyDeco">
        {{ i18n.t('mini_my_bets_no_pending_bets') }}
    </div>
</template>

<script lang="ts" setup>
    import { i18n } from '@/core/lib/i18n';
</script>
